import { tuple } from './type';
export var PresetStatusColorTypes = tuple('success', 'processing', 'error', 'default', 'warning');
export var PresetStatusTypes = tuple('inactive', 'active', 'processing', 'success', 'error', 'warning');
// eslint-disable-next-line import/prefer-default-export
export var PresetColorTypes = tuple('blue', 'red', 'green', 'orange', 'grey');